import { dataAtom, dataComposer } from "@frend-digital/centra";

import type { CentraProduct } from "@/lib/centra/atomicSetup";
import { baseAtomics } from "@/lib/centra/atomicSetup";

import { getIsNew, getSeries, getShape } from "../../localAtomics";

const { getName, getUri, getVariantName } = baseAtomics;

const getProductCore = (product: CentraProduct) => {
  const name = dataAtom(getVariantName, 2)(product);
  const slug = dataAtom(getUri, 2)(product);
  const variantName = dataAtom(getVariantName, 2)(product);
  const isNew = dataAtom(getIsNew, 2)(product);
  const shape = dataAtom(getShape, 2)(product);
  const series = dataAtom(getSeries, 2)(product);

  const core = dataComposer({
    name,
    slug,
    variantName,
    isNew,
    shape,
    series
  });

  return core;
};

export default getProductCore;
